module.exports = __webpack_public_path__ + "static/img/content_coming_soon.4b0925b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/content_coming_soon.png
// module id = JPUI
// module chunks = 0